import {DomEventSubscription, EventListenerRegistration} from '../../../utils/event-listener-registration';

export class WindowEventListenerRegistration extends EventListenerRegistration {
    scroll = (handler: EventListenerOrEventListenerObject): DomEventSubscription => {

        if(this._scrollContainerElement) {
            this._scrollContainerElement.addEventListener('scroll', handler);
            return {
                dispose: () => this._scrollContainerElement?.removeEventListener('scroll', handler)
            };
        } else {
            return super.scroll(handler);
        }

    }

    private _scrollContainerElement = null;
    setScrollContainer(element: HTMLElement): void {
        this._scrollContainerElement = element;
    }

    unload = (handler: EventListenerOrEventListenerObject): DomEventSubscription => {
        return this._subscribe('unload', handler);
    }
}